import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const  Industriel = () => {
    return ( 
        <Container>
        <Row>
          <Col xs={12} md={12}>
          <Figure className="itemsimg">
          <Figure.Caption>
  <p><h2><span className="fontcolor">BUK COMMERCIALS SERVICES DIVISION</span></h2></p>
            <p><h4>BUK Commercials Services DIVISION prime business is to procure high end equipment such as for the mines,
road construction, fire services, sanitary garbage trucks, cranes, transformers and medical equipment etc.</h4></p>
  </Figure.Caption>
        <Figure.Image
          width={850}
          height={850}
          alt="171x180"
          src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596766/nonedb/Industriel_Vehicles_ufr7td.jpg"
        />
        <Figure.Caption>
          
        </Figure.Caption>
      </Figure>  
            
          </Col>
        </Row>
        
      </Container>
     );
}
 
export default Industriel ;